import { forwardRef } from 'react';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import { BankingOptionCards } from '#client/components/BankingOptions';
import useBankingOptionCards from '#client/hooks/useBankingOptionCards';

import { BANKING_LANDING_OPTION_EVENTS } from '../constants';

/**
 * The wind-down replacement for `Offers`: Mercury and Bank of America instead of the
 * ZenBusiness, Bluevine and Chase offers.
 */
export const PartnerOffers = forwardRef((props, ref) => {
  const cards = useBankingOptionCards(BANKING_LANDING_OPTION_EVENTS);

  return (
    <Stack
      spacing={4}
      {...props}
      ref={ref}
    >
      <Text
        color="primary"
        size="xl"
        weight="medium"
      >
        Business Banking Solutions
      </Text>
      <BankingOptionCards cards={cards} />
    </Stack>
  );
});
